import type { FaireProductEntity } from "../../entity_types/product";

export const p_4rf273tyjf: FaireProductEntity = {
  token: "p_4rf273tyjf",
  type: "product",
  name: "Haunted House Matches",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/033f7ad18b87c6157e757f26031b71c43d0f66b42a9302d039981208a2296ff7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d8d4dc1926a98adf65de99ce1b2db0b0d9d943f17e75f52537205958f07aab8b.jpeg",
    "https://cdn.faire.com/fastly/79efbf7edb91ed66f1855ede457bbd8071c6c6b6b4456341e73854805f8819fc.jpeg",
    "https://cdn.faire.com/fastly/a3f8919852f88a7b396dde560608264e09bf89bf6937044f7b7c811c9a9b2b0f.jpeg",
    "https://cdn.faire.com/fastly/0f2a3821d509dae12fd2d4665fbfa521cd441f566a5af0ff13a610eef3b86747.jpeg",
    "https://cdn.faire.com/fastly/de9a9b84f19927039c0c85babf8ae70ebc42a99ec5b68b295a6376e2dd170bcc.jpeg",
  ],
  priceDollars: 8.31,
  description:
    '\nEnter if you dare ‼️\n\nThese matches make me want to go to a haunted house and come home to watch scary movies 👻 Comes in a haunted-house-shaped box with lavender tipped matches! Perfect addition to your spooky decor and/or match collection!! \n\nThis matchbox measures approx. 1.75" x 2.25" x 2.5"\n\nComes with approximately 70 matches. The striker is on the side of the box. \n\nThis design is the sole property of A Shop Of Things and Burning Love and cannot be reproduced or copied for any reason without my permission beforehand. ©\n',
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:08.773Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
